"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var cosmosBase_1 = __importDefault(require("./cosmosBase"));
var Juno = /** @class */ (function (_super) {
    __extends(Juno, _super);
    function Juno() {
        var _this = _super.call(this) || this;
        _this.lcd = "https://lcd-juno.itastakers.com";
        _this.stakingDocUrl =
            "https://support.ledger.com/hc/en-us/articles/6235986236957-Earn-Osmosis-OSMO-staking-rewards-in-Ledger-Live?docs=true";
        _this.defaultGas = 100000;
        _this.unbondingPeriod = 28;
        _this.validatorOperatorAddressPrefix = "junovaloper";
        _this.ledgerValidator = "";
        return _this;
    }
    return Juno;
}(cosmosBase_1["default"]));
exports["default"] = Juno;
//# sourceMappingURL=Juno.js.map